import { traverse, Transformer, anyObj } from "./traverse";
import { htmlNamedEscapes } from './htmlNamedEscapes'

export const htmlEncode = (unsafeString: string) => {
    const safeString = unsafeString.replace(
        // /[\u00A0-\u9999<>\&]/gim,           // Catch all unsafe unicode characters
        /[<>'"\&]/gim,
        (x) => `&#${x.charCodeAt(0)};` // Encode as &#<unicode-number>;
    );
    return safeString;
};

export const htmlDecode = (safeString: string) => {
    const unsafeString = safeString
        // Decimal case
        .replace(/\&#(\d+);/gm, (_, unicode) => String.fromCharCode(parseInt(unicode, 10)))
        // Hex case
        .replace(/\&#x([A-f,a-f,0-9]+);/gm, (_, unicode) => String.fromCharCode(parseInt(unicode, 16)))
        // Named escapes
        .replace(/&(\w{2,8});/g, (str, name) => htmlNamedEscapes[name] || str);
    return unsafeString;
};

const encodeTransformer: Transformer = (obj: anyObj) => {
    const copy: anyObj = obj instanceof Array ? [] as any: {};
    Object.entries(obj).forEach(([key, value]) => {
        copy[htmlEncode(key)] = typeof value === 'string' ? htmlEncode(value) : value;
    });
    return copy;
}
export const encodedJSONStringify = (obj: object) => {
    return JSON.stringify(traverse(obj, encodeTransformer));
};

export const encodedJSONParse = (json: string) => {
    return JSON.parse(json, (_, value) => (typeof value === 'string' ? htmlDecode(value) : value));
};
